"use client";
import {
  Navbar as NextUINavbar,
  NavbarContent,
  NavbarMenu,
  NavbarMenuToggle,
  NavbarItem,
  NavbarMenuItem,
  NavbarBrand,
} from "@heroui/navbar";
import { Link } from "@heroui/link";
import NextLink from "next/link";
import { Icon } from "@iconify/react";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/popover";
import { useState, useRef } from "react";

import useNavbar from "./useNavbar";

import {
  CompaniesNav,
  ThemeSwitch,
  CottonLogo,
  FindTalent,
  ApplyForJob,
} from "@/components";

const Navbar = () => {
  const {
    navItems,
    navMenuItems,
    isMenuOpen,
    currentPath,
    OfferNavRef,
    handleMenuToggle,
  } = useNavbar();

  // 🔥 NEW: Companies mobile state
  const [isCompaniesOpenMobile, setIsCompaniesOpenMobile] = useState(false);
  const CompaniesRefMobile = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={OfferNavRef} className="bg-background z-50 fixed w-full">
      <NextUINavbar
        className="overflow-hidden transition-all duration-300 ease-in-out items-start"
        classNames={{
          wrapper: "lg:px-28 px-4 max-w-screen-2xl mx-auto",
        }}
        isBlurred={false}
        isMenuOpen={isMenuOpen}
        maxWidth="full"
        position="sticky"
        onMenuOpenChange={handleMenuToggle}
      >
        {/* 🔹 Mobile Logo */}
        <NavbarContent className="sm:hidden flex items-center" justify="start">
          <NextLink href="/">
            <CottonLogo />
          </NextLink>
        </NavbarContent>

        {/* 🔹 Desktop Left */}
        <NavbarBrand className="hidden sm:block">
          <NextLink href="/">
            <CottonLogo />
          </NextLink>
        </NavbarBrand>

        <NavbarContent className="hidden sm:flex" justify="center">
          {/* 🔥 Desktop Companies */}
          <NavbarItem>
            <Popover offset={12} placement="bottom">
              <PopoverTrigger>
                <button className="hover:text-primary flex items-center gap-1">
                  Companies
                  <Icon icon="solar:alt-arrow-down-linear" width="16" />
                </button>
              </PopoverTrigger>

              <PopoverContent
                className="fixed! left-1/2! pb-3 w-screen
      -translate-x-1/2! max-w-max
       rounded-xl bg-background
        border
        border-default/50
        shadow-xl
        "
                // shadow-[0_10px_10px_-5px_rgba(0,0,0,0.04),0_6px_6px_-3px_rgba(0,0,0,0.04),0_3px_3px_-1.5px_rgba(0,0,0,0.04),0_1px_1px_-0.5px_rgba(0,0,0,0.04),0_0_0_0.5px_var(--neutral-200)]
              >
                <CompaniesNav setOpenCompanies={() => {}} />
              </PopoverContent>
            </Popover>
          </NavbarItem>

          <NavbarItem>
            <ul className="hidden lg:flex items-center gap-4 ml-2">
              {navItems.map((item, index) => (
                <NavbarItem key={index}>
                  <NextLink
                    className={`${
                      currentPath === item.href && "text-primary"
                    } hover:text-primary text-foreground transition-all`}
                    href={item.href as string}
                  >
                    {item.label}
                  </NextLink>
                </NavbarItem>
              ))}
            </ul>
          </NavbarItem>
        </NavbarContent>

        {/* 🔹 Desktop Right */}
        <NavbarContent
          className="hidden sm:flex items-center basis-1/5 sm:basis-full"
          justify="end"
        >
          <div className="flex gap-3">
            <FindTalent />
            <ApplyForJob />
          </div>

          <NavbarItem className="hidden lg:flex gap-2">
            <ThemeSwitch />
          </NavbarItem>
        </NavbarContent>

        {/* 🔹 Mobile Toggle */}
        <NavbarContent className="lg:hidden basis-1 pl-4" justify="end">
          <ThemeSwitch />
          <NavbarMenuToggle />
        </NavbarContent>

        {/* 🔥 MOBILE MENU */}
        <NavbarMenu>
          <div className="mx-4 mt-2 flex flex-col gap-3">
            {navMenuItems.map((item, index) => (
              <div key={index}>
                <NavbarMenuItem>
                  <Link
                    href={item.href}
                    onPress={() => handleMenuToggle(false)}
                  >
                    {item.label}
                  </Link>
                </NavbarMenuItem>
              </div>
            ))}

            {/* 🔥 NEW: Companies (Mobile) */}
            <div ref={CompaniesRefMobile}>
              <button
                className="flex items-center gap-2 text-primary"
                onClick={() => setIsCompaniesOpenMobile((prev) => !prev)}
              >
                Companies
                <Icon
                  className={`${
                    isCompaniesOpenMobile ? "-rotate-180" : ""
                  } transition-all`}
                  icon="solar:alt-arrow-down-linear"
                />
              </button>

              {isCompaniesOpenMobile && isMenuOpen && (
                <div className="mt-2 mb-5">
                  <CompaniesNav setOpenCompanies={() => {}} />
                </div>
              )}
            </div>
          </div>
        </NavbarMenu>
      </NextUINavbar>
    </div>
  );
};

export default Navbar;
